// Contracts — moderator's own bookings list («Мои заявки», Tim 09.07). A moderator
// sees the landing/intake bookings attributed to THEM via meetings.referrer_moderator_id
// (written on INSERT by handleLandingIntake / handleIntakeCreate, migration 0029).
// Read-only monitoring: parent name + phone (so the mod can call the lead) + children
// (name/age) + date/time/status, recent-first. Self-scoped — GET /api/kids/mod/
// landing-bookings takes no user id; the worker keys on the caller's own id.
import { z } from 'zod';

// A child summary on a booking row (name + age for the list; nothing sensitive).
export const KidsModBookingChildSchema = z.object({
  name: z.string(),
  age: z.number().int().nullable(),
});
export type KidsModBookingChild = z.infer<typeof KidsModBookingChildSchema>;

export const KidsModBookingSchema = z.object({
  meetingId: z.string(),
  parentName: z.string(),
  // Phone is nullable — the landing form makes it optional (landing.ts). Shown as a
  // copyable value in the UI so the moderator can call the lead.
  parentPhone: z.string().nullable(),
  office: z.string(),
  date: z.string(), // YYYY-MM-DD (office-local)
  time: z.string(), // HH:MM family start
  status: z.string(), // scheduled|checked_in|… (meetings.status)
  source: z.string(), // landing|onsite (how the booking came in)
  createdAt: z.number().int(),
  children: z.array(KidsModBookingChildSchema),
});
export type KidsModBooking = z.infer<typeof KidsModBookingSchema>;

// ── GET /api/kids/mod/landing-bookings (moderator; self-scoped) ──────────────
export const KidsModBookingsResSchema = z.object({
  bookings: z.array(KidsModBookingSchema),
});
export type KidsModBookingsRes = z.infer<typeof KidsModBookingsResSchema>;
